// Dependencies
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

/**
 * @description
 * dispatch request headers to update detail
 *
 * @header string|internal_code
 * @header string|name
 * @header string|wh_warehouse_name
 * @header number|quantity_requested
 */
export default [
    {
        text: 'código interno',
        value: 'internal_code',
        width: '10%',
    },
    {
        text: 'nombre',
        value: 'name',
        component: {
            custom: 'id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'bodega',
        value: 'wh_warehouse_name',
        input: {
            class: 'ma-0 pa-0',
            clearable: false,
            custom: 'wh_warehouse',
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            outline: false,
            solo: false,
            type: 'autocomplete-model',
        },
        width: '15%',
    },
    {
        text: 'cantidad',
        value: 'quantity_requested',
        format: 'number',
        align: 'right',
        input: {
            reverse: true,
            type: 'float-field',
        },
        width: '10%',
    },
]
